import { storage as localStorage } from "./localStorage";
export var getInitialDarkMode = function getInitialDarkMode() {
  return localStorage().getDarkMode();
};